var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover:border-indigo-500 border-2 cursor-pointer",on:{"click":_vm.openDetail}},[_c('img',{attrs:{"src":_vm.clip.thumbnail_url}})])}
var staticRenderFns = []

export { render, staticRenderFns }